/**
 * @generated SignedSource<<fb3a7c21b8d77beed230b9179aa27f13>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RunnerStatus = "IDLE" | "PREPARING" | "RUNNING" | "SHARED" | "%future added value";
export type RunnersQuery$variables = {
  name: string;
};
export type RunnersQuery$data = {
  readonly organization: {
    readonly queuedJobInfos: ReadonlyArray<{
      readonly jobId: string;
      readonly " $fragmentSpreads": FragmentRefs<"QueuedJob_info">;
    }>;
    readonly runners: ReadonlyArray<{
      readonly id: string;
      readonly slots: number;
      readonly status: RunnerStatus;
      readonly " $fragmentSpreads": FragmentRefs<"Runner_runner">;
    }>;
  } | null | undefined;
};
export type RunnersQuery = {
  response: RunnersQuery$data;
  variables: RunnersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "name",
    "variableName": "name"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slots",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jobId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "repository",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalUrl",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RunnersQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Runner",
            "kind": "LinkedField",
            "name": "runners",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "Runner_runner"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GithubWorkflowJobInfo",
            "kind": "LinkedField",
            "name": "queuedJobInfos",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "QueuedJob_info"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RunnersQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Runner",
            "kind": "LinkedField",
            "name": "runners",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "organizationName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "VirtualMachineInfo",
                "kind": "LinkedField",
                "name": "vmInfo",
                "plural": false,
                "selections": [
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GithubWorkflowJobInfo",
                "kind": "LinkedField",
                "name": "assignedGitHubJob",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "owner",
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "conclusion",
                    "storageKey": null
                  },
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "completedAt",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GithubWorkflowJobInfo",
            "kind": "LinkedField",
            "name": "queuedJobInfos",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v3/*: any*/),
              (v6/*: any*/),
              (v9/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5c1316ed630214edeb6fdac71a8fc0f3",
    "id": null,
    "metadata": {},
    "name": "RunnersQuery",
    "operationKind": "query",
    "text": "query RunnersQuery(\n  $name: String!\n) {\n  organization(name: $name) {\n    runners {\n      id\n      status\n      slots\n      ...Runner_runner\n    }\n    queuedJobInfos {\n      jobId\n      ...QueuedJob_info\n    }\n    id\n  }\n}\n\nfragment QueuedJob_info on GithubWorkflowJobInfo {\n  jobId\n  repository\n  name\n  status\n  image\n  externalUrl\n}\n\nfragment Runner_runner on Runner {\n  id\n  status\n  slots\n  organizationName\n  vmInfo {\n    image\n  }\n  assignedGitHubJob {\n    jobId\n    owner\n    repository\n    name\n    status\n    conclusion\n    externalUrl\n    createdAt\n    startedAt\n    completedAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "5fe7d1ef0e3ff18c30d997c1140af6a9";

export default node;
